import type { ComponentProps } from "react";

// Heroicons (24/outline) has no thermometer, so this matches their conventions
// — 24 viewBox, 1.5 stroke, round caps — and inherits color/size from whatever
// className it's given, like a real Heroicon. One tube-and-bulb path.
export const ThermometerIcon = (props: ComponentProps<"svg">) => (
    <svg
        viewBox="0 0 24 24"
        fill="none"
        stroke="currentColor"
        strokeWidth={1.5}
        strokeLinecap="round"
        strokeLinejoin="round"
        {...props}
    >
        <path d="M14 14.76V5a2 2 0 1 0-4 0v9.76a4 4 0 1 0 4 0Z" />
    </svg>
);
